import React, { Component } from 'react';
import { connect } from "react-redux";
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';;
import AgentTabDesc from "../agents/AgentTabDesc";
import TrafficDatatable from "./TrafficDatatable";

@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Traffic extends Component {

    constructor(props) {
        super(props);
        this.onSelectTab=this.onSelectTab.bind(this);
    }

    onSelectTab(k){

    //    console.log(window["table"+k]);
    //    window["table"+k].columns.adjust().draw();

    }
    superViseChat(id){
        if(this.state.supervise===true){
            this.props.dispatch(superViseChat(id));
            this.setState({
                supervise:false
            });
            //setTimeout(this.openSupervise, 5000);
            console.log("tıklandı");
        } else{
            console.log("tıklanamaz");
        }

    }
    openSupervise(){
        this.setState({
            supervise:true
        });

    }
    componentDidMount() {
        this.props.dispatch({
            type: 'SET_MENU',
            data: "traffic"
        });
    }

    render() {

        const { t } = this.props;
        return (
            <React.Fragment>
                <div className="chat  d-flex align-items-center justify-content-center traffic-datatable" id="middle">
                    <div className="sidebar-body" id="chatsidebar">
                        <nav>
                            <Tabs defaultActiveKey="chatting" className="filter-tab" onSelect={(k)=>this.onSelectTab(k)}>
                                <Tab eventKey="all"  title={"All ("+Object.keys(this.props.chatprop.customers).length+")"}>
                                    <TrafficDatatable type="all" id="all" />
                                </Tab>
                                <Tab eventKey="chatting"  title={"Chatting ("+Object.keys(this.props.chatprop.customers.filter(cs => cs.activity == "chatting")).length+")"}>
                                    <TrafficDatatable type={(cs=>cs.activity==="chatting")} id="chatting" />
                                </Tab>
                                <Tab eventKey="queued"  title={"Queued ("+Object.keys(this.props.chatprop.customers.filter(cs => cs.activity == "queued")).length+")"}>
                                    <TrafficDatatable type={(cs=>cs.activity==="queued")}  id="queued" />
                                </Tab>

                            </Tabs>
                        </nav>
                    </div>
                </div>

            </React.Fragment>
        );
    }
}

export default Traffic;
